module.exports = __webpack_public_path__ + "media/images/wizform-logo-1a139559796ba8c8ebbc63edeef7b89a.png";